<template>
  <div>
    <div v-bind:key="index" v-for="(question, index) in partyQuestions">
      <toggle-group
        :label="question.question"
        :helper="question.helper"
        :required="true"
        :options="question.answers"
        v-model="question.answer"
        v-on:input="setAnswers"
        :readonly="readonly"
        :disabled="readonly"
      ></toggle-group>
    </div>
  </div>
</template>

<script>
import ToggleGroup from './../../../Generic/ToggleGroup';

export default {
  props: {
    party: Object,
    questions: Array,
    type: String,
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    'toggle-group': ToggleGroup
  },

  data() {
    return {
      partyQuestions: [],
      highlightClasses: ['btn-danger', 'btn-warning', 'btn-success']
    };
  },

  mounted() {
    this.setPartyQuestions();
  },

  methods: {
    setPartyQuestions() {
      this.questions
        .filter(question => question.partyType.name === this.type)
        .forEach(question => {
          const answer = this.findAnswer(question.id);

          if (!answer) {
            this.party.qualification_answers.push({
              question_id: question.id,
              answer_id: null
            });
          }

          this.partyQuestions.push({
            question_id: question.id,
            question: question.question,
            helper: question.helper,
            answers: question.answers.map((answer, i) => {
              return {
                value: answer.id,
                label: answer.body,
                highlight: this.highlightClasses[i]
              };
            }),
            answer: answer ? answer.answer_id : null
          });
        });
    },

    setAnswers() {
      this.partyQuestions.forEach(question => {
        const answer = this.findAnswer(question.question_id);

        if (answer) {
          answer.answer_id = question.answer;
        }
      });
    },

    findAnswer(questionId) {
      return this.party.qualification_answers.find(
        answer => answer.question_id == questionId
      );
    }
  },

  watch: {
    questions() {
      this.setPartyQuestions();
    }
  }
};
</script>
